:host {
  display: block;
  /* background-color: green; */
  width: 700px;
  min-height: 200px;
}

h3 {
    font-family: Roboto, "Helvetica Neue", sans-serif;
    font-weight: 300;
}

.text-content {
    padding: 8px;
}

.chart-controls button {
    margin-right: 8px;
}

.chart-box {
    display: block;
    width: 100%;
    position: relative;
}

.chart-box p {
    margin: 0;
}


.lift-ticks {
    transform: translateY(50);
}

.axis-label {
    font-size: 16px;
    transform: translate(0, 20);
    font-family: Roboto, sans-serif;
}

.tick-mark {
    display: none;
}


.tail {
    fill: white;
}

.text-box {
    box-sizing: border-box;
    position: absolute;
    display: inline-block;
}

.text-box.right {
    text-align: end;
}

.item-line {
    stroke: rgba(0, 0, 0, 0.7);
}

.ls-line:hover {
    cursor: pointer;
}

text.anchor {
    fill: #3f51b5;
    font-weight: 600;
}

.item-line.anchor {
    stroke: #3f51b5;
}

svg {
    font-family: sans-serif;
}